import GrillaFacturas from '../../moleculas/GrillaFacturas/GrillaFacturas'


function GrillaFacturasContainer() {
  return (
    <div> 
      <GrillaFacturas/>
    </div>
  )
}

export default GrillaFacturasContainer